/** Why a route guard rejected the signed-in user; selects the explanation ForbiddenState shows. */
export const FORBIDDEN_REASONS = {
  permission: 'permission',
  tenantAdminOnly: 'tenantAdminOnly',
  superAdminOnly: 'superAdminOnly',
} as const;

export type ForbiddenReason = (typeof FORBIDDEN_REASONS)[keyof typeof FORBIDDEN_REASONS];
